import { estClient } from './estClient';

export interface AppealsConfig {
  appeals_notify_inactive?: '1' | '';
  appeals_notify_inactive_timeout?: number;
  appeals_notify_inactive_managers?: number[];
}

interface AppealsConfigResponse {
  success: boolean;
  config: AppealsConfig;
}

const normalize = (raw: AppealsConfig): AppealsConfig => ({
  ...raw,
  appeals_notify_inactive: raw.appeals_notify_inactive ? '1' : '',
});

class AppealsConfigApi {
  async get(): Promise<AppealsConfig> {
    const resp = await estClient.get<AppealsConfigResponse | AppealsConfig>(
      '/api/config',
    );
    const config = 'config' in resp ? resp.config : resp;

    return normalize(config);
  }

  async update(body: AppealsConfig): Promise<AppealsConfig> {
    const resp = await estClient.post<AppealsConfigResponse | AppealsConfig>(
      '/api/config',
      { body },
    );
    const config = 'config' in resp ? resp.config : resp;

    return normalize(config);
  }
}

export const appealsConfigApi = new AppealsConfigApi();
